import { render } from "./CustomerVoice.vue?vue&type=template&id=baaf117c"
import script from "./CustomerVoice.vue?vue&type=script&lang=js"
export * from "./CustomerVoice.vue?vue&type=script&lang=js"

import "./CustomerVoice.vue?vue&type=style&index=0&id=baaf117c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__